<template>
  <div>
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      class="container mx-auto max-w-[1200px] w-full py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div class="flex justify-end px-6">
        <router-link
          :to="{ name: 'InstructorHome' }"
          class="bg-[#18469d] text-white rounded-lg text-sm font-semibold px-5 py-1"
          >Back</router-link
        >
      </div>
      <!-- <SyallbusView/> -->
      <div class="w-full h-full flex flex-col gap-5">
        <div
          class="flex flex-col md:flex-row md:items-center md:justify-between"
        >
          <div>
            <h1 class="text-xl font-semibold">
              Syllabus <span class="text-[16px]"> ({{ count_list || 0 }})</span>
            </h1>
          </div>
          <div class="flex flex-col md:flex-row gap-3">
            <div>
              <form
                @submit.prevent="searchUserValue"
                class="flex w-full md:w-auto"
              >
                <input
                  type="text"
                  name="search"
                  id="search"
                  v-model="search_list"
                  @input="searchUserValue"
                  placeholder="Type to Search"
                  class="border-2 rounded-l-xl px-4 py-1.5 w-full md:w-[230px] outline-none"
                />
                <!-- <div class="flex justify-end items-center gap-3">
                <div class="flex justify-end items-center gap-3 hidden">
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-gray-200 text-black cursor-not-allowed'
                        : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                    "
                    class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                  >
                    Update
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div> -->

                <button
                  type="submit"
                  class="bg-[#18469d] py-2 md:py-1 rounded-r-xl text-white px-4"
                >
                  <img
                    src="@/assets/search.webp"
                    alt="Search"
                    class="w-6 h-6"
                  />
                </button>
              </form>
            </div>
            <button
              @click="this.addsyllabus = true"
              class="bg-[#18469d] text-white font-semibold text-xs px-4 py-2 rounded-xl"
            >
              Add Syllabus
            </button>
          </div>
        </div>
        <div>
          <div class="w-full overflow-scroll border">
            <table class="min-w-full">
              <thead>
                <tr
                  class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                >
                  <th class="px-6 py-3">S.No</th>
                  <th class="px-6 py-3">Title</th>
                  <th class="px-6 py-3">Year</th>
                  <th class="px-6 py-3">Pdf</th>
                  <th class="px-6 py-3">Command</th>
                  <th class="px-6 py-3">Edit</th>
                  <th class="px-6 py-3">Delete</th>
                </tr>
              </thead>
              <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
                <tr class="w-full">
                  <td colspan="12" class="text-center py-6">
                    <div class="flex items-center justify-center">
                      <img src="@/assets/attendance/loading.gif" alt="" />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <template v-if="syllabus_list.length > 0">
                  <tr
                    v-for="(list, index) in syllabus_list"
                    :key="index"
                    class="border-b border-[#afdaec] text-left text-sm"
                  >
                    <td class="px-6 py-3">
                      {{ (currentPage - 1) * perPage + index + 1 }}
                    </td>
                    <td class="px-6 py-3">{{ list.title }}</td>
                    <td class="px-6 py-3">
                      {{ list.years }}
                    </td>
                    <td class="px-6 py-3">
                      <a :href="list.pdf" target="_blank" class="text-blues">{{
                        list.pdf?.split("/")?.pop() || "-"
                      }}</a>
                    </td>
                    <td class="px-6 py-3">
                      <p class="break-words">{{ list.command }}</p>
                    </td>
                    <td class="px-6 py-3">
                      <button @click="openEditPopup(list.id)" class="">
                        <img
                          src="@/assets/new/medit.png"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EDF8FF] p-1"
                        />
                      </button>
                    </td>
                    <td class="px-6 py-3">
                      <button
                        @click="
                          titlepass = list.title;
                          popupwindow = true;
                          idpass = list.id;
                        "
                        class=""
                      >
                        <img
                          src="@/assets/new/dele.png"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#FF29291A] p-1"
                        />
                      </button>
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="12" class="px-6 py-3 text-center">
                    No Data Found
                  </td>
                </tr>
              </tbody>
              <!-- <tfoot>
            <tr>
              <td colspan="12" class="p-6 bg-[#18469d]"></td>
            </tr>
          </tfoot> -->
            </table>
          </div>
          <div
            v-if="syllabus_list.length > 0"
            class="flex justify-center py-4 space-x-2 p-6 bg-[#18469d]"
          >
            <button
              class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
              :disabled="currentPage === 1"
              @click="prevPage"
            >
              &laquo;
            </button>

            <button
              v-for="page in visiblePages"
              :key="page"
              class="px-3 py-2 rounded"
              :class="{
                'bg-white text-blues': currentPage === page,
                'bg-white border border-gray-400 text-gray-800':
                  currentPage !== page,
              }"
              @click="changePage(page)"
            >
              {{ page }}
            </button>

            <button
              class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
              :disabled="currentPage >= totalPages"
              @click="nextPage"
            >
              &raquo;
            </button>
          </div>
        </div>
        <!-- Add popup -->
        <div
          v-if="this.addsyllabus"
          @click.self="this.addsyllabus = false"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-center">
              <h3 class="text-xl font-bold text-blues text-center">
                Add Syllabus
              </h3>
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="createTeamRef"
                  @submit.prevent="createSyllabus"
                  class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_title"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Title</span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive title
                        </div>
                      </div>
                    </label>

                    <input
                      required
                      id="syllabus_title"
                      type="text"
                      placeholder="Title"
                      class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_date"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Year <span class="text-red-400">*</span></span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive year YYYY-dd
                        </div>
                      </div>
                    </label>
                    <input
                      required
                      id="syllabus_date"
                      type="text"
                      placeholder="YYYY-dd"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_pdf" class="text-left"
                      >Pdf <span class="text-red-400">*</span></label
                    >
                    <input
                      id="syllabus_pdf"
                      type="file"
                      multiple
                      accept=".pdf"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      required
                    />
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_command" class="text-sm"
                      >Command</label
                    >
                    <textarea
                      id="syllabus_command"
                      required
                      maxlength="1000"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                    ></textarea>
                  </div>

                  <div class="flex justify-center pb-4 mt-3 gap-10">
                    <button
                      @click="this.addsyllabus = false"
                      class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Close
                    </button>
                    <div class="flex justify-end items-center gap-3">
                      <button
                        type="submit"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                        "
                        class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                      >
                        Add
                      </button>
                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>

                    <!-- <button
                      type="submit"
                      class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Submit
                    </button> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Edit popup -->
        <div
          v-if="this.isEditing"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-center">
              <h3 class="text-xl font-bold text-blues text-center">
                Edit Syllabus
              </h3>
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="createTeamRef"
                  @submit.prevent="editSyllabus"
                  class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_title"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Title</span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive title
                        </div>
                      </div>
                    </label>

                    <input
                      id="syllabus_title"
                      v-model="editsyllabus_list.title"
                      type="text"
                      class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_date"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Year <span class="text-red-400">*</span></span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive year YYYY-dd
                        </div>
                      </div>
                    </label>
                    <input
                      id="syllabus_date"
                      type="text"
                      v-model="editsyllabus_list.years"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_pdf" class="text-left"
                      >Pdf <span class="text-red-400">*</span></label
                    >

                    <input
                      id="syllabus_pdf"
                      type="file"
                      accept=".pdf"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="handleFileUpload"
                    />
                    <a
                      v-if="editsyllabus_list.pdf"
                      :href="editsyllabus_list.pdf"
                      target="blank"
                      class="text-sm text-blues"
                      >{{ editsyllabus_list.pdf.split("/").pop() }}</a
                    >
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_command" class="text-sm"
                      >Command</label
                    >
                    <textarea
                      id="syllabus_command"
                      maxlength="1000"
                      v-model="editsyllabus_list.command"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                    ></textarea>
                  </div>

                  <div class="flex justify-center pb-4 mt-3 gap-10">
                    <button
                      @click="this.isEditing = false"
                      class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Close
                    </button>
                    <div class="flex justify-end items-center gap-3">
                      <button
                        type="submit"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                        "
                        class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                      >
                        Update
                      </button>
                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                    <!-- <button
                      type="submit"
                      class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Submit
                    </button> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- delect popup -->

        <div
          v-if="popupwindow"
          class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
          style="z-index: 5000"
        >
          <div class="w-[90%] lg:w-[35%] rounded-md m-4">
            <div
              class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
            >
              <img
                @click="popupwindow = false"
                class="absolute right-2 top-2 cursor-pointer"
                src="@/assets/newd/close.png"
              />
              <p class="text-center font-base text-xl text-gray-600">
                Are you sure want to delete ?
              </p>
              <h1 class="text-center font-bold text-xl text-teal-600">
                {{ titlepass }}
              </h1>
            </div>
            <div
              class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-200"
            >
              <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
                <!-- <button
                  @click="deleteSyllabus"
                  class="bg-teal-800 hover:bg-teal-600 text-white text-sm font-semibold rounded overflow-hidden px-4 py-2"
                >
                  Yes
                </button> -->
                <div class="flex justify-end items-center gap-3">
                  <button
                    type="submit"
                    @click="deleteSyllabus"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-white text-black cursor-not-allowed'
                        : 'bg-teal-800 hover:bg-teal-600 cursor-pointer text-white'
                    "
                    class="rounded-lg border text-sm px-4 font-semibold py-2"
                  >
                    Yes
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
                <button
                  @click="popupwindow = false"
                  class="bg-white hover:bg-gray-300 text-gray-700 text-sm font-semibold rounded overflow-hidden px-4 py-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
// import SyallbusView from "@/components/SyallbusView.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      addsyllabus: false,
      isEditing: false,
      popupwindow: false,
      messages: {
        text: "",
        type: "null",
      },
      // loading: true,
      syllabus_list: [],
      editsyllabusId: null,
      editsyllabus_list: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 5,
      pageArray: [],
      perPage: 10,
      titlepass: null,
      idpass: null,
      search_list: "",
      count_list: "",
      disable_submit: false,
    };
  },
  components: {
    Header,
    // SyallbusView,
    FlashMessage,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    visiblePages() {
      const start =
        Math.floor((this.currentPage - 1) / this.pageSize) * this.pageSize;
      const end = Math.min(start + this.pageSize, this.totalPages);
      return this.pageArray.slice(start, end);
    },
  },
  watch: {
    syllabus_list() {
      this.pageArray = [];
      for (let i = 1; i < this.totalPages + 1; i++) {
        this.pageArray.push(i);
      }
    },
  },
  created() {
    this.getSyllabus(1);
  },
  methods: {
    async getSyllabus(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/syllabus-overall-list/?page=${page}&search=${this.search_list}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.syllabus_list = response.data.data.data;
            this.count_list = response.data.total;
          } else {
            console.log("got error");
          }
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getSyllabus(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getSyllabus(this.currentPage);
      }
    },

    changePage(page) {
      this.currentPage = page;
      this.getSyllabus(page);
    },
    async createSyllabus(event) {
      this.disable_submit = true;
      const el = event.target;

      let token = this.userInfo.token_key;

      let urls = `${process.env.VUE_APP_API}/syllabus-create/?Key=${token}`;
      let formData = new FormData();

      formData.append("title", el.elements.syllabus_title.value);

      formData.append("years", el.elements.syllabus_date.value);

      formData.append("command", el.elements.syllabus_command.value);
      formData.append("user", this.userInfo.user.id);
      console.log("formData", formData);
      const fileInput = el.elements.syllabus_pdf;
      if (fileInput && fileInput.files.length > 0) {
        for (let i = 0; i < fileInput.files.length; i++) {
          formData.append("pdf", fileInput.files[i]);
          await axios
            .post(urls, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              console.log(response, "respionse");
              if (response.data.status == 200) {
                this.messages = {
                  text: response.data.message,
                  type: "success",
                };
                setTimeout(() => {
                  this.messages = {
                    text: "",
                    type: "null",
                  };
                   this.disable_submit = false;
                  this.addsyllabus = false;
                }, 1500);
              } else {
                this.messages = {
                  text: " Event Faild",
                  type: "error",
                };
                setTimeout(() => {
                  this.messages = {
                    text: "",
                    type: "null",
                  };
                    this.disable_submit = false;
                }, 2000);
              }
            })
            .finally(() => {
            
            });
        }
        setTimeout(() => {
          this.disable_submit = false;
          el.reset();
          this.getSyllabus(1);
          this.changePage(1);
        }, 2000);
        // this.getSyllabus(this.totalPages);
        // this.changePage(this.totalPages);
        // this.currentPage = this.totalPages+1;
        // if(this.syllabus_list > 10){
        //   this.currentPage = this.totalPages;
        // }
      }
    },
    openEditPopup(id) {
      this.editsyllabusId = id;
      axios
        .get(
          `${process.env.VUE_APP_API}/syllabus-overall-list/?Key=${this.userInfo.token_key}&id=${id}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.editsyllabus_list = response.data.data.data[0];
          } else {
            console.log("got error");
          }
        });

      this.isEditing = true;
    },
    handleFileUpload(event) {
      this.thumbnailFile = event.target.files[0];
    },
    async editSyllabus(e) {
      this.disable_submit = true;
      let updatedEditInfo = new FormData();
      updatedEditInfo.append("title", e.target.elements.syllabus_title.value);
      updatedEditInfo.append("years", e.target.elements.syllabus_date.value);
      updatedEditInfo.append(
        "command",
        e.target.elements.syllabus_command.value
      );

      if (this.thumbnailFile) {
        updatedEditInfo.append("pdf", this.thumbnailFile);
      }

      await axios
        .put(
          `${process.env.VUE_APP_API}/syllabus-retrieve-update/${this.editsyllabusId}/?Key=${this.userInfo.token_key}`,
          updatedEditInfo
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        })
        .finally(() => {
          // this.disable_submit = false;
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.isEditing = false;
         this.disable_submit = false;
        this.getSyllabus(this.currentPage);
      }, 2500);
    },
    async deleteSyllabus() {
       this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/syllabus-retrieve-update/${this.idpass}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.popupwindow = false;
          this.disable_submit = false;
        this.getSyllabus(1);
        this.changePage(1);
      }, 2500);
    },
    async searchUserValue() {
      this.currentPage = 1;
      this.getSyllabus(1);
      this.changePage(1);
    },
  },
};
</script>

<style></style>
